module.exports = __webpack_public_path__ + "static/media/logo.e5a9a58c.svg";